export class RfpDetails {
  supplier_name: any;
  supplierContactPerson_name: any;

  // ============ 🔥 DISCOUNT FIELDS ============
  isDiscountActive: boolean = false;
  discountType: string = 'Line Item Discount';   // 'Line Item Discount' | 'Total Amount Discount'
  discountMode: string = 'Percentage';            // 'Percentage' | 'Flat Amount'
  totalDiscountValue: number = 0;
  // ============================================

  constructor(
    public rfp_id?: string,
    public rfp_code?: string,
    public vendor_id?: string,
    public vendor_code?: string,
    public lead_time?: string,
    public credit_days?: string,
    public additional_charges?: number,
    public total_charges?: number,
    public remark?: string,
    public itemPriceParameter: ItemPriceParameter[] = [],
    public vendorBiddingFiles?: UploadedFile[],

    public establishmentDate?: string,
    public contactNo?: string,
    public mailId?: string,
    public website?: string,
    public nameOfPanOwner?: string,
    public company_id?: number,
    public rfp_FileUpload?: string,
    public vendorEmployees?: VendorEmployee[],
    public technicalDetails?: technicalDetails[],
    public vendorQuestionAnswer: vendorQuestionAnswer[] = [],
  ) {
    this.rfp_id = rfp_id;
    this.rfp_code = rfp_code;
    this.vendor_id = vendor_id;
    this.vendor_code = vendor_code;
    this.lead_time = lead_time;
    this.credit_days = credit_days;
    this.additional_charges = additional_charges;
    this.total_charges = total_charges;
    this.remark = remark;
    this.rfp_FileUpload = rfp_FileUpload;
    this.itemPriceParameter = itemPriceParameter;
    this.vendorBiddingFiles = vendorBiddingFiles;

    this.establishmentDate = establishmentDate;
    this.contactNo = contactNo;
    this.mailId = mailId;
    this.website = website;
    this.nameOfPanOwner = nameOfPanOwner;
    this.company_id = company_id;
    this.vendorEmployees = vendorEmployees;
    this.technicalDetails = technicalDetails;
    this.vendorQuestionAnswer = vendorQuestionAnswer;

    // 🔥 Defaults for discount fields
    this.isDiscountActive = false;
    this.discountType = 'Line Item Discount';
    this.discountMode = 'Percentage';
    this.totalDiscountValue = 0;
  }
}

interface VendorEmployee {
  vendor_id: any;
  vendorEmpName: string;
  vendorEmpContact: string;
  vendorEmpMail: string;
  vendorEmpDesignation: string;
  vendorEmpAddress: string;
}

export class UploadedFile {
  vendorBiddingFiles?: any;
  fileExtension?: any;
}

export class ItemPriceParameter {
  item_id?: number;
  item_code?: string;
  item_name?: string;
  itemAmount?: number;
  quantity?: any;
  price_param?: Priceparam[];
}

export class Priceparam {
  priceParam_id?: string;
  priceParam_name?: string;
  priceParam_prize?: string;
}

export interface technicalDetails {
  technicalQuestion?: any;
  points?: any;
  weightage?: number;
  vendorValue?: any;
}

export interface vendorQuestionAnswer {
  correctAnswer?: any;
  question?: any;
  weightage?: any;
  answer?: any;
  remark?: any;
  question_id?: any;
  questionType?: any;
  mandatory?: any;
  document?: any;
  file?: any;
  fileExtension?: any;
}